export default __webpack_public_path__ + "static/media/Mobile Screenshot 3.362fb000.png";